"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameMenu = void 0;
const fill_select_element_1 = require("../../../../../utils/fill-select-element");
const label_1 = require("../../../../../view-components/label/label");
const optionsLevel = {
    name: ['Level_1', 'Level_2', 'Level_3', 'Level_4', 'Level_5', 'Level_6', 'Level_7']
};
const optionsRound = {
    name: [...Array(45).keys()].map((i) => i + 1)
};
class GameMenu {
    constructor(id) {
        this.form = document.createElement('form');
        this.form.id = id;
        this.form.name = id;
    }
    render() {
        const levelSelect = document.createElement('select');
        levelSelect.id = 'level-select';
        (0, fill_select_element_1.fillSelect)(optionsLevel.name, levelSelect);
        const labelLevelSelect = label_1.labelEl.render('level-select');
        labelLevelSelect.innerText = 'Change level';
        const roundSelect = document.createElement('select');
        roundSelect.id = 'round-select';
        (0, fill_select_element_1.fillSelect)(optionsRound.name, roundSelect);
        const labelRoundSelect = label_1.labelEl.render('round-select');
        labelRoundSelect.innerText = 'Choose round';
        this.form.append(labelLevelSelect);
        this.form.append(levelSelect);
        this.form.append(labelRoundSelect);
        this.form.append(roundSelect);
        return this.form;
    }
}
exports.GameMenu = GameMenu;
